import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { spacing, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		backgroundColor: 'transparent !important',
		boxSizing: 'border-box',
		height: '100%',
		paddingTop: spacing.lg,
		width: '100%',
	},
	databoardContainer: {
		backgroundColor: 'transparent !important',
		boxSizing: 'border-box',
		height: '100%',
		width: '100%',
	},
	filters: {
		marginBottom: spacing.md,
	},
	filterField: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	filterLabel: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
	},
	excludeActivityTrigger: {
		backgroundColor: colors.background.light,
	},
	exportAction: {
		alignSelf: 'flex-end',
		marginLeft: 'auto',
	},
	exclusionNote: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		margin: `0 0 ${spacing.md}px`,
	},
	statSkeleton: {
		height: 22,
		width: 64,
	},
	statCaption: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xxs,
		marginTop: spacing.xs,
	},
});
